import React, { useState, useEffect, createContext } from 'react';
import { jwtDecode } from 'jwt-decode';
import { getActiveRole, getAuthToken, getSessionRole, setActiveRole } from '../utils/authStorage';

export const UserContext = createContext();

export const UserContextProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const token = getAuthToken();
    if (token) {
      try {
        const decoded = jwtDecode(token);
        console.log("🔍 [FRONTEND] Token dekódolt adatok:", decoded);

        let requiresRoleSelection = false;
        let activeRole = getActiveRole();
        const isDualRole = decoded.isAdmin && decoded.isSzakfelelos;
        
        if (isDualRole) {
          activeRole = getSessionRole();

          if (!activeRole) {
            requiresRoleSelection = true;
            localStorage.removeItem('activeRole');
          }
        } else if (!activeRole) {
          if (decoded.isAdmin || decoded.isSuperUser) {
            activeRole = 'admin';
          } else if (decoded.isSzakfelelos) {
            activeRole = 'szakfelelos';
          }
          
          if (activeRole) {
            setActiveRole(activeRole, true);
          }
        }

        const normalizedRole = activeRole || null;

        setUserData({
          name: decoded.name || "Ismeretlen felhasználó", 
          neptun: decoded.neptun || null,
          isSuperUser: decoded.isSuperUser || false,
          isAdmin: decoded.isAdmin || false,
          isSzakfelelos: decoded.isSzakfelelos || false,
          role: normalizedRole,
          requiresRoleSelection,
          token: token
        });
      } catch (err) {
        console.error('❌ [FRONTEND] Érvénytelen token:', err);
        setUserData(null);
      }
    }
  }, []);

  return (
    <UserContext.Provider value={{ userData, setUserData }}>
      {children}
    </UserContext.Provider>
  );
};
